import { CrudTableAction, CrudTableState } from './interfaces';

export const getInitialState = <EntityCrudData>(): CrudTableState<EntityCrudData> => ({
  isOpen: true,
  isLoading: true,
  isValidating: false,
  originalDataSource: null,
  dataSource: null,
  actionId: null,
  reviewInfo: null,
  view: 'all',
  cloneType: 'new',
  showIds: false,
  columnsEditAll: {},
  validationFeedback: null,
  isValid: false,
  activeCell: null,
  disableCancel: false,
});

// sonarjs:cognitive-complexity -- ignore
export function reducer<EntityCrudData>(
  prevState: CrudTableState<EntityCrudData>,
  action: CrudTableAction<EntityCrudData>,
): CrudTableState<EntityCrudData> {
  switch (action.type) {
    case 'open':
      if (!action.dataSource || !action.originalDataSource) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...getInitialState(),
        originalDataSource: action.originalDataSource,
        dataSource: action.dataSource,
      };
    case 'openReview':
      if (!action.dataSource || !action.originalDataSource || !action.actionId || !action.validationFeedback)
        throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...getInitialState(),
        originalDataSource: action.originalDataSource,
        dataSource: action.dataSource,
        actionId: action.actionId,
        reviewInfo: action.reviewInfo ?? null,
        validationFeedback: action.validationFeedback,
        isLoading: false,
      };
    case 'setActionId':
      if (!action.actionId) throw new Error(`Invalid action provided ${action.type}`);
      return { ...prevState, actionId: action.actionId };
    case 'setFeedback':
      if (!action.validationFeedback || action.isValid === undefined) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...prevState,
        validationFeedback: action.validationFeedback,
        isValid: action.isValid,
        isValidating: false,
      };
    case 'setIsValid':
      if (action.isValid === undefined) throw new Error(`Invalid action provided ${action.type}`);
      return { ...prevState, isValid: action.isValid };
    case 'setIsLoading':
      if (action.isLoading === undefined) throw new Error(`Invalid action provided ${action.type}`);
      return { ...prevState, isLoading: action.isLoading };
    case 'setIsValidating':
      if (action.isValidating === undefined) throw new Error('Invalid action provided');
      return { ...prevState, isValidating: action.isValidating };
    case 'setView':
      if (!action.view) throw new Error(`Invalid action provided ${action.type}`);
      return { ...prevState, view: action.view };
    case 'setDataSource':
      if (!action.dataSource) throw new Error(`Invalid action provided ${action.type}`);
      return { ...prevState, dataSource: action.dataSource };
    case 'setResult':
      if (!action.dataSource || !action.validationFeedback) throw new Error(`Invalid action provided ${action.type}`);
      return { ...prevState, dataSource: action.dataSource };
    case 'setCloneType':
      if (!action.cloneType) throw new Error(`Invalid action provided ${action.type}`);
      return { ...prevState, cloneType: action.cloneType };
    case 'setActiveCell':
      if (action.activeCell === undefined) throw new Error(`Invalid action provided ${action.type}`);
      return { ...prevState, activeCell: action.activeCell };
    case 'toggleColumnEditAll':
      if (!action.columnKey) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...prevState,
        columnsEditAll: { ...prevState.columnsEditAll, [action.columnKey]: !prevState.columnsEditAll[action.columnKey] },
      };
    case 'setShowIds':
      if (action.showIds === undefined) throw new Error(`Invalid action provided ${action.type}`);
      return { ...prevState, showIds: action.showIds };
    case 'setDisableCancel':
      return { ...prevState, disableCancel: true };
    case 'close':
      return {
        ...prevState,
        isOpen: false,
      };
    default:
      throw new Error(`No action provided ${action.type}`);
  }
}
